module.exports = __webpack_public_path__ + "static/media/422-west.9f9129e1.png";